import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay, Navigation, Mousewheel, Parallax } from 'swiper/modules';

export class Slider extends AbstractComponent {
  init() {
    new Swiper(this.el.querySelector('.swiper'), {
      slidesPerView: 1.1,
      spaceBetween: 15,
      modules:  [Navigation, Mousewheel],
      breakpoints: {
        768: {
          slidesPerView: Number(this.el.dataset.perView) / 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: Number(this.el.dataset.perView) / 1.25,
        },
        1440: {
          slidesPerView: Number(this.el.dataset.perView),
        },

      },
      navigation: {
        nextEl: ".is-next",
        prevEl: ".is-prev",
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    });
  }
}

register('slider', Slider);
